import Vue from 'vue';
import VueRouter from 'vue-router';
//index
const main = () => import('@/views/main/main');
// 404
const NotFound = () => import(/* webpackChunkName: "404" */ '@/views/404/index');
const index = () => import('@/views/index/index');
const details = () => import('@/views/index/details');

const logistics = () => import('@/views/logistics/index');

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    meta: { title: '404' },
    component: NotFound,
  },
  {
    path: '/index',
    component: main,
    meta: { title: '' },
    children: [
      {
        path: '',
        component: index,
        meta: { title: '' },
      },
      {
        path: ':id',
        component: index,
        meta: { title: '' },
      },
      {
        path: 'details/:id',
        component: details,
        meta: { title: '商品详情' },
      },
    ],
  },
  {
    path: '/logistics',
    meta: { title: '物流追踪' },
    component: logistics,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
